var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTheRealityText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6893.197,
    height: 4594.563,
    viewBox: "0 0 6893.197 4594.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1275",
    "data-name": "Group 1275",
    transform: "translate(-6564.736 24227.758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M0,3994.564H6893.2V-600H0Z",
    transform: "translate(6564.736 -23627.76)",
    fill: "#b0cfcc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1274",
    "data-name": "Group 1274",
    transform: "translate(19321 -20495)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_444",
    "data-name": "Ellipse 444",
    cx: 342,
    cy: 342,
    r: 342,
    transform: "translate(-7190 -342)",
    fill: "#0e7f8a",
    opacity: 0.095
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_445",
    "data-name": "Ellipse 445",
    cx: 188.5,
    cy: 188.5,
    r: 188.5,
    transform: "translate(-11922 -3589)",
    fill: "#0e7f8a",
    opacity: 0.095
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3186",
    "data-name": "Path 3186",
    d: "M-664.539,3347.65s-64.815-407.41,240.742-231.482,157.409-296.295,314.816-231.479,250,314.813,453.706-37.039",
    transform: "matrix(0.995, 0.105, -0.105, 0.995, -7583.015, -2721.666)",
    fill: "none",
    stroke: "#397d88",
    strokeWidth: 20,
    opacity: 0.39
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheRealityText);
export default __webpack_public_path__ + "static/media/theRealityText.015090e2b5525c912848b0a9c4b1c085.svg";
export { ForwardRef as ReactComponent };